export const ErrorTimeout = -1;
export const LogLevel = 'INFO';
export const StorageLevel = "public";
